var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from 'angular-ts-decorators';
import { OrganizationController } from './organization.controller';
import { OrganizationService } from './organization.service';
import { BackendModule } from '../backend/backend.module';
import { UserModule } from '../user/user.module';
import 'angular';
let OrganizationModule = class OrganizationModule {
};
OrganizationModule = __decorate([
    NgModule({
        id: 'OrganizationModule',
        imports: [BackendModule, UserModule],
        declarations: [OrganizationController],
        providers: [OrganizationService],
        bootstrap: [],
    })
], OrganizationModule);
export { OrganizationModule };
// Required, because we wanna use this controller via 'ng-controller="OrganizationController as main" in our HTML,
// otherwise the controller is not known by name:
OrganizationModule.module.controller('OrganizationController', OrganizationController);
